import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../../../services/transaksi/TransaksiService'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { FaArrowLeft, FaEdit, FaPlus, FaSave, FaTrash } from 'react-icons/fa'
import DataTable from 'react-data-table-component'
import ModalViewMutuArea from './modal/ModalViewMutuArea'
import Propinsi from '../../../../utilities/Propinsi'
import KotaKab from '../../../../utilities/KotaKab'
import SweetAlert from 'react-bootstrap-sweetalert'

const ViewMutuArea = ({ dataMutuArea, saveMutuArea, cancelMutuArea }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])

    const [loading, setLoading] = useState()
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)

    useEffect(() => {
        if (!dataMutuArea) return
        setLoading(true)
        setListData(dataMutuArea.data)
        setTotalData(dataMutuArea.totalData)
        setLoading(false)
    }, [dataMutuArea])

    const handleChangePage = async (page) => {
        const _res = await transaksiService.listPpmMutuArea(localStorage.getItem('nomorAjuStorage'), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await transaksiService.listPpmMutuArea(localStorage.getItem('nomorAjuStorage'), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trPpkMutuAreaPK'].mutuAreaSeri,
            grow: 0
        },
        {
            name: 'Sumber',
            cell: row => row['mutuArea'] === '1' ? 'Aqua Cultured / Area Cultured' : (row['mutuArea'] === '2' ? 'Wild Cought / Area Tangkap' : ''),
        },
        {
            name: 'Prop',
            cell: row => row['mutuCultProp'] && <Propinsi id={row['mutuCultProp']} />
        },
        {
            name: 'Kota',
            cell: row => row['mutuCultKota'] && <KotaKab id={row['mutuCultKota']} />
        },
        {
            name: 'Nama Budidaya',
            cell: row => row['mutuBudidayaNama']
        },
        {
            name: 'Jenis Budidaya',
            cell: row => row['mutuBudidayaJenis'] === '1' ? 'Pembenihan' : (row['mutuBudidayaJenis'] === '2' ? 'Budidaya' : '')
        },
        {
            name: 'Area Tangkap',
            cell: row => row['mutuTangkapArea']
        },
        {
            name: 'Nama Kapal',
            cell: row => row['mutuTangkapKapal']
        },
        {
            name: 'Nama Kapal',
            cell: row => row['mutuTangkapKapal']
        },
        {
            name: 'Nomor Sertifikat',
            cell: row => row['mutuNomorSertifikat']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-12 mb-1'>
                            {localStorage.getItem('isEditStorage') === '1' ?
                                <>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Ubah</Tooltip>}>
                                        <Button size='sm' variant='warning' onClick={() => handleClickEditMutuArea(row, true)}>
                                            <FaEdit />
                                        </Button>
                                    </OverlayTrigger>{' '}
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Hapus</Tooltip>}>
                                        <Button size='sm' variant='danger' onClick={() => handleClickHapusMutuArea(row)}>
                                            <FaTrash />
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </> : ''
                            }
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        }
    ]

    const [isEdit, setIsEdit] = useState(false)
    const [dataArea, setDataArea] = useState(null)
    const [nomorAju, setNomorAju] = useState(null)
    const [showMutuArea, setShowMutuArea] = useState(false)
    const handleCloseMutuArea = () => setShowMutuArea(false)

    const handleClickAddMutuArea = () => {
        setIsEdit(true)
        setNomorAju(localStorage.getItem('nomorAjuStorage'))
        setShowMutuArea(true)
    }
    const handleClickEditMutuArea = (row, isEdit) => {
        setDataArea(row)
        setNomorAju(row.trPpkMutuAreaPK.nomorAju)
        setIsEdit(isEdit)
        setShowMutuArea(true)
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [loadingHapus, setLoadingHapus] = useState(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)

    const handleClickHapusMutuArea = (row) => {
        setDataArea(row)
        setShowConfirmHapus(true)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonAreaPK = {
                nomorAju: dataArea.trPpkMutuAreaPK.nomorAju,
                mutuAreaSeri: dataArea.trPpkMutuAreaPK.mutuAreaSeri
            }
            const response = await transaksiService.deletePpmMutuAreaById(jsonAreaPK)
            if (response.data.kode === '200') {
                setShowConfirmHapus(false)
                setShowHapusSucces(true)
            } else {
                setShowConfirmHapus(false)
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowConfirmHapus(false)
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        handleChangePage(1)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
        handleChangePage(1)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Data Sumber Produk</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-8">
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickAddMutuArea()}><FaPlus />Tambah Sumber Produk</Button>{'  '}
                            </div>
                            :
                            ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listData}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalData}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveMutuArea('dokumen')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelMutuArea('mutuprod')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }
            <ModalViewMutuArea showMutuArea={showMutuArea} handleCloseMutuArea={handleCloseMutuArea} dataArea={dataArea} nomorAju={nomorAju} reloadList={handleChangePage} isEdit={isEdit} />
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Data Sumber?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingHapus}
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Hapus data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Sumber Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Sumber Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewMutuArea